import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import { Button, Chip, CircularProgress, Stack } from '@mui/material';
import React from 'react';

export default function PaymentStatusControl({ paymentStatus, onChange, saving = false }) {
  const isPaid = paymentStatus === 'paid';

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.75}>
      <Chip
        color={isPaid ? 'success' : 'warning'}
        icon={isPaid ? <CheckCircleRoundedIcon /> : <PendingOutlinedIcon />}
        label={isPaid ? 'Платена' : 'Неплатена'}
        size="small"
        sx={{ width: 112, '& .MuiChip-label': { textAlign: 'center', width: '100%' } }}
        variant={isPaid ? 'filled' : 'outlined'}
      />
      <Button
        aria-label={isPaid ? 'Маркирай като неплатена' : 'Маркирай като платена'}
        color={isPaid ? 'inherit' : 'warning'}
        disabled={saving}
        onClick={() => onChange(isPaid ? 'pending' : 'paid')}
        size="small"
        startIcon={saving ? <CircularProgress color="inherit" size={14} /> : <CheckCircleRoundedIcon />}
        sx={{
          minWidth: 112,
          width: 112,
          minHeight: 24,
          height: 24,
          px: 0.75,
          py: 0,
          fontSize: '0.75rem',
          lineHeight: 1,
          whiteSpace: 'nowrap',
          '& .MuiButton-startIcon': { mr: 0.35, ml: 0 },
          '& .MuiSvgIcon-root': { fontSize: 16 }
        }}
        variant={isPaid ? 'text' : 'outlined'}
      >
        {isPaid ? 'Неплатена' : 'Платена'}
      </Button>
    </Stack>
  );
}
